import { useUiModeStore } from '@/features/ui-mode/store/ui-mode-store';
import type { MarkerSize } from '@/features/ui-mode/store/ui-mode-store';
import type { StatusColors } from '../utils/marker-style';

interface MarkerCustomization {
  statusColors: StatusColors;
  markerColor: string | null;
  markerSize: MarkerSize | null;
}

/**
 * Read the marker customization set via the `cluster_*` URL params.
 * Returns the per-status ring/pin colors, the center-circle accent, and the
 * size override. All values default to "no override" so absent params leave
 * marker rendering unchanged.
 */
export function useMarkerCustomization(): MarkerCustomization {
  const available = useUiModeStore((s) => s.markerColorAvailable);
  const busy = useUiModeStore((s) => s.markerColorBusy);
  const disconnected = useUiModeStore((s) => s.markerColorDisconnected);
  const error = useUiModeStore((s) => s.markerColorError);
  const markerColor = useUiModeStore((s) => s.markerColor);
  const markerSize = useUiModeStore((s) => s.markerSize);

  return {
    statusColors: { available, busy, disconnected, error },
    markerColor,
    markerSize,
  };
}
